(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["d-header-menu"] && !Shopify.designMode) return;
  try {
    class MegaMenuDropdown extends HTMLElement {
    connectedCallback() {
      this._state = {
        activeIndex: null,
        activeChildKey: null,
        activeLeafKey: null,
        activeThirdTitle: null,
        suppressDefault: false,
      };
      this._productCache = {};
      this._mediaRequestToken = 0;

      this._bind();
    }

    _bind() {
      this.addEventListener('mouseenter', () => this._showBanners());
      this.addEventListener('mouseleave', () => this._resetAll());
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this._resetAll();
      });

      this.querySelectorAll('[data-lvl1-index]').forEach((item) => {
        const activate = () => {
          this._activateLvl1(
            parseInt(item.dataset.lvl1Index),
            item.dataset.hasChildren === 'true'
          );
          this._updateMedia(item.dataset.collectionHandle || null);
        };
        item.addEventListener('mouseenter', activate);
        item.addEventListener('focusin', activate);
      });

      this.querySelectorAll('[data-lvl2-key]').forEach((item) => {
        const activate = () => {
          if (item.dataset.hasLvl4 === 'true') {
            this._activateLvl2(item.dataset.lvl2Key, item.dataset.lvl2Title);
          } else {
            this._clearLvl2(item.dataset.lvl2Title);
          }
          this._updateMedia(item.dataset.collectionHandle || null);
        };
        item.addEventListener('mouseenter', activate);
        item.addEventListener('focusin', activate);
      });
    }

    _resetAll() {
      this._invalidateMediaRequests();
      this._state = {
        activeIndex: null,
        activeChildKey: null,
        activeLeafKey: null,
        activeThirdTitle: null,
        suppressDefault: false,
      };
      this._render();
      this._showBanners();
    }

    _activateLvl1(index, hasChildren) {
      const s = this._state;
      s.suppressDefault = !hasChildren;
      s.activeIndex = hasChildren ? index : null;
      s.activeChildKey = null;
      s.activeLeafKey = null;
      s.activeThirdTitle = null;
      this._render();
    }

    _activateLvl2(key, title) {
      const s = this._state;
      s.activeChildKey = key;
      s.activeLeafKey = key;
      s.activeThirdTitle = title;
      this._render();
    }

    _clearLvl2(title) {
      const s = this._state;
      s.activeChildKey = null;
      s.activeLeafKey = null;
      s.activeThirdTitle = title;
      this._render();
    }

    _render() {
      const s = this._state;

      this.classList.toggle('is-lvl2-active', s.activeIndex !== null);
      this.classList.toggle('is-lvl3-active', s.activeChildKey !== null);

      // Lvl1 active state
      this.querySelectorAll('[data-lvl1-index]').forEach((item) => {
        item.classList.toggle('is-active', parseInt(item.dataset.lvl1Index) === s.activeIndex);
      });

      // Lvl2 panels
      this.querySelectorAll('[data-lvl1-target]').forEach((panel) => {
        panel.style.display = parseInt(panel.dataset.lvl1Target) === s.activeIndex ? '' : 'none';
      });

      // Lvl3 panels
      this.querySelectorAll('[data-lvl3-key]').forEach((panel) => {
        panel.style.display = panel.dataset.lvl3Key === s.activeChildKey ? '' : 'none';
      });

      // Lvl2 items active state
      this.querySelectorAll('[data-lvl2-key]').forEach((item) => {
        const key = item.dataset.lvl2Key;
        const title = item.dataset.lvl2Title;
        const isActive =
          key === s.activeLeafKey ||
          (s.activeLeafKey === null && title === s.activeThirdTitle && s.activeChildKey === null);
        item.classList.toggle('is-active', isActive);
      });
    }

    _invalidateMediaRequests() {
      this._mediaRequestToken += 1;
    }

    _updateMedia(collectionHandle) {
      const requestToken = ++this._mediaRequestToken;

      if (!collectionHandle) {
        this._hideBoth();
        return;
      }
      if (this._productCache[collectionHandle]) {
        if (requestToken !== this._mediaRequestToken) return;
        this._renderProducts(this._productCache[collectionHandle]);
        return;
      }
      fetch(`/collections/${collectionHandle}/products.json?limit=4`)
        .then((r) => r.json())
        .then((data) => {
          if (requestToken !== this._mediaRequestToken) return;
          this._productCache[collectionHandle] = data.products || [];
          this._renderProducts(this._productCache[collectionHandle]);
        })
        .catch(() => {
          if (requestToken !== this._mediaRequestToken) return;
          this._hideBoth();
        });
    }

    _hideBoth() {
      const banners = this.querySelector('.d-header-nav__banners');
      const products = this.querySelector('.d-header-nav__products');
      if (banners) banners.style.display = 'none';
      if (products) {
        products.style.display = 'none';
        products.innerHTML = '';
      }
    }

    _showBanners() {
      this._invalidateMediaRequests();
      const banners = this.querySelector('.d-header-nav__banners');
      const products = this.querySelector('.d-header-nav__products');
      if (banners) banners.style.display = '';
      if (products) {
        products.style.display = 'none';
        products.innerHTML = '';
      }
    }

    _escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    _formatPrice(price) {
      const num = parseFloat(price);
      if (isNaN(num)) return '';
      return 'R$\u00a0' + num.toFixed(2).replace('.', ',');
    }

    _renderProducts(products) {
      const container = this.querySelector('.d-header-nav__products');
      const banners = this.querySelector('.d-header-nav__banners');
      if (!container) return;

      container.innerHTML = products
        .slice(0, 4)
        .map((p) => {
          const img = p.images && p.images[0];
          if (!img) return '';
          const src = img.src.replace(/\.(jpg|jpeg|png|webp|gif)(\?|$)/i, '_480x.$1$2');
          const alt = this._escapeHtml(img.alt || p.title);
          const v = p.variants && p.variants[0];
          const price = v ? this._formatPrice(v.price) : '';
          const compareAt = v && v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)
            ? this._formatPrice(v.compare_at_price)
            : '';
          return `<a href="/products/${p.handle}" class="d-header-nav__product-item">
            <div class="d-header-nav__product-img">
              <img src="${src}" alt="${alt}" loading="lazy" width="480" height="480">
            </div>
            <div class="d-header-nav__product-info">
              <p class="d-header-nav__product-title">${this._escapeHtml(p.title)}</p>
              <div class="d-header-nav__product-prices">
                ${compareAt ? `<s class="d-header-nav__product-compare">${compareAt}</s>` : ''}
                ${price ? `<span class="d-header-nav__product-price${compareAt ? ' d-header-nav__product-price--sale' : ''}">${price}</span>` : ''}
              </div>
            </div>
          </a>`;
        })
        .join('');

      if (banners) banners.style.display = 'none';
      container.style.display = '';
    }
  }

  customElements.define('mega-menu-dropdown', MegaMenuDropdown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["d-notifications"] && !Shopify.designMode) return;
  try {
    class NotificationsSidebar extends HTMLElement {
    connectedCallback() {
      this._readNotifications = JSON.parse(localStorage.getItem('readNotifications')) || [];

      this._trigger = this.querySelector('[data-open-notifications]');
      this._backdrop = this.querySelector('[data-backdrop]');
      this._dialog = this.querySelector('[data-dialog]');
      this._closeBtn = this.querySelector('[data-close-notifications]');
      this._countEl = this.querySelector('.notification-count');
      this._items = this.querySelectorAll('[data-notification-handle]');

      this._items.forEach((item) => {
        const handle = item.dataset.notificationHandle;
        if (!this._isRead(handle)) item.classList.add('unread');
        item.addEventListener('click', () => this._markAsRead(handle));
      });

      this._updateTrigger();

      this._trigger?.addEventListener('click', () => this._open());
      this._backdrop?.addEventListener('click', () => this._close());
      this._closeBtn?.addEventListener('click', () => this._close());

      this._onKeydown = (e) => { if (e.key === 'Escape') this._close(); };
      window.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      window.removeEventListener('keydown', this._onKeydown);
    }

    _open() {
      this._backdrop.classList.add('is-open');
      this._dialog.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    _close() {
      this._backdrop.classList.remove('is-open');
      this._dialog.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    _isRead(id) {
      return this._readNotifications.includes(id);
    }

    _markAsRead(id) {
      if (this._isRead(id)) return;
      this._readNotifications.push(id);
      localStorage.setItem('readNotifications', JSON.stringify(this._readNotifications));
      const item = this.querySelector(`[data-notification-handle="${id}"]`);
      if (item) item.classList.remove('unread');
      this._updateTrigger();
    }

    _updateTrigger() {
      const unreadCount = [...this._items].filter(
        (item) => !this._isRead(item.dataset.notificationHandle)
      ).length;

      if (this._countEl) {
        this._countEl.textContent = unreadCount;
        this._countEl.classList.toggle('is-visible', unreadCount > 0);
      }

      if (this._trigger) {
        this._trigger.classList.toggle('has-unread', unreadCount > 0);
      }
    }
  }

  customElements.define('notifications-sidebar', NotificationsSidebar);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["d-sticky-atc"] && !Shopify.designMode) return;
  try {
    class StickyAtc extends HTMLElement {
    connectedCallback() {
      // Move to body so position:fixed is not broken by ancestor transforms
      // (Dawn scroll animations use CSS transform on ancestors).
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }

      if (this._initialized) return;
      this._initialized = true;

      this._sectionId = this.dataset.sectionId;
      this._submitBtnId = this.dataset.submitButtonId;
      this._variantInput = this.querySelector('[data-sticky-variant-id]');
      this._priceEl = this.querySelector('[data-sticky-price]');
      this._addBtn = this.querySelector('[data-sticky-add]');
      this._qtyInput = this.querySelector('[data-sticky-qty]');
      this._selects = Array.from(this.querySelectorAll('[data-sticky-option]'));

      const variantsJson = this.querySelector('[data-sticky-variants]');
      this._variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

      this._setupObserver();
      this._setupQty();
      this._setupSelects();
      this._setupAddButton();
      this._setupVariantSync();
    }

    _setupObserver() {
      const target = document.getElementById(this._submitBtnId);
      if (!target) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const isVisible = !entry.isIntersecting;
            this.classList.toggle('is-visible', isVisible);
            this._toggleBodyOffset(isVisible);
          });
        },
        { threshold: 0.1 }
      );

      observer.observe(target);
    }

    _toggleBodyOffset(isVisible) {
      document.body.classList.toggle('has-sticky-atc', isVisible);
      if (isVisible) {
        document.documentElement.style.setProperty('--d-sticky-atc-offset', `${this.offsetHeight}px`);
      } else {
        document.documentElement.style.removeProperty('--d-sticky-atc-offset');
      }
    }

    _setupQty() {
      const minus = this.querySelector('[data-sticky-qty-minus]');
      const plus = this.querySelector('[data-sticky-qty-plus]');
      if (!minus || !plus || !this._qtyInput) return;

      minus.addEventListener('click', () => {
        const val = parseInt(this._qtyInput.value, 10) || 1;
        if (val > 1) this._qtyInput.value = val - 1;
      });

      plus.addEventListener('click', () => {
        const val = parseInt(this._qtyInput.value, 10) || 1;
        this._qtyInput.value = val + 1;
      });

      this._qtyInput.addEventListener('change', () => {
        const val = parseInt(this._qtyInput.value, 10);
        if (!val || val < 1) this._qtyInput.value = 1;
      });
    }

    _setupSelects() {
      this._selects.forEach((select) => {
        select.addEventListener('change', () => this._syncVariantFromSelects());
      });
    }

    _syncVariantFromSelects() {
      const selectedOptions = this._selects.map((s) => s.value);
      const match = this._variants.find((v) =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
      if (match) {
        this._variantInput.value = match.id;
        this._updatePrice(match.price);
        this._updateButtonState(match.available);
      }
    }

    _updatePrice(price) {
      if (!this._priceEl) return;
      // Preco de parceria B2E: espelha o calculo feito no Liquid do snippet.
      const partnerPct = parseInt(this.dataset.partnerPct, 10) || 0;
      const finalPrice = partnerPct > 0 ? Math.round((price * (100 - partnerPct)) / 100) : price;
      this._priceEl.textContent = this._formatMoney(finalPrice);
    }

    _formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.money_format) {
        const amount = (cents / 100).toFixed(2);
        return Shopify.money_format
          .replace(/\{\{\s*amount\s*\}\}/, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
      }
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    _updateButtonState(available) {
      if (!this._addBtn) return;
      const textEl = this._addBtn.querySelector('.d-sticky-atc__btn-text');
      this._addBtn.disabled = !available;
      if (textEl) textEl.textContent = available ? 'Adicionar' : (window.variantStrings?.soldOut || 'Esgotado');
    }

    _setupVariantSync() {
      if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const { sectionId, variant } = event.data || {};
        if (sectionId !== this._sectionId || !variant) return;

        this._variantInput.value = variant.id;
        this._updatePrice(variant.price);
        this._updateButtonState(variant.available);

        if (variant.options && this._selects.length) {
          variant.options.forEach((optValue, i) => {
            if (this._selects[i]) this._selects[i].value = optValue;
          });
        }
      });
    }

    _setupAddButton() {
      if (!this._addBtn) return;
      this._addBtn.addEventListener('click', async () => {
        const variantId = parseInt(this._variantInput.value, 10);
        const quantity = parseInt(this._qtyInput?.value, 10) || 1;
        if (!variantId) return;

        this._setLoading(true);
        try {
          await this._cartAdd(variantId, quantity);
        } catch (e) {
          console.error('[StickyAtc] cart add error:', e);
        } finally {
          this._setLoading(false);
        }
      });
    }

    _setLoading(loading) {
      if (!this._addBtn) return;
      this._addBtn.classList.toggle('loading', loading);
      this._addBtn.toggleAttribute('aria-busy', loading);
      const spinner = this._addBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !loading);
    }

    _getCartComponent() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    async _cartAdd(variantId, quantity) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
      });

      if (!res.ok) throw new Error('[StickyAtc] cart add failed: ' + res.status);

      const response = await res.json();
      const cartComponent = this._getCartComponent();

      if (cartComponent && typeof cartComponent.getSectionsToRender === 'function') {
        const sectionIds = cartComponent.getSectionsToRender().map((s) => s.id);
        const sectionsRes = await fetch('/?sections=' + sectionIds.join(','));
        const sections = await sectionsRes.json();

        cartComponent.classList.remove('is-empty');
        if (typeof cartComponent.setActiveElement === 'function') {
          cartComponent.setActiveElement(document.activeElement);
        }

        const firstItem = response.items ? response.items[0] : response;
        cartComponent.renderContents({
          id: response.id || firstItem?.id,
          key: response.key || firstItem?.key,
          sections,
        });
      }

      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-atc', cartData: response });
      }

      return response;
    }
  }

  customElements.define('sticky-atc', StickyAtc);
  } catch(e) { console.error(e); }
})();

})();
